<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          v-for="filter in filterOptions"
          :key="filter.type"
          :class="[
            filter.type === filterType && 'text-primary',
          ]"
          style="width: 33%; display: flex; flex-direction: column; align-items: center;"
          role="button"
          @click="$emit('update:filter-type', filter.type)"
        >
          <feather-icon size="21" :icon="filter.icon" />
          <b-card-text>{{ $t(`communications.${filter.type}`) }}</b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BRow, BCol } from 'bootstrap-vue'
import { COMMUNICATION_TYPES } from '@/shared/constants/communications'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
  },
  props: {
    filterType: {
      type: String,
      default: COMMUNICATION_TYPES.ANNOUNCEMENT,
    },
  },
  data() {
    return {
      filterOptions: this.$store.state.app.appConfig.type === 'hw-admin' ?
        [
          {
            type: COMMUNICATION_TYPES.ANNOUNCEMENT,
            icon: 'FlagIcon',
          },
          {
            type: COMMUNICATION_TYPES.SMS,
            icon: 'MailIcon',
          },
          {
            type: COMMUNICATION_TYPES.CAMPAIGN,
            icon: 'StarIcon',
          },
          {
            type: COMMUNICATION_TYPES.QUESTIONNAIRE,
            icon: 'CheckSquareIcon',
          },
        ]
      : [
      {
            type: COMMUNICATION_TYPES.ANNOUNCEMENT,
            icon: 'FlagIcon',
          },
          {
            type: COMMUNICATION_TYPES.SMS,
            icon: 'MailIcon',
          },
          {
            type: COMMUNICATION_TYPES.QUESTIONNAIRE,
            icon: 'CheckSquareIcon',
          },
      ]
    }
  },
}
</script>

<style>
</style>